import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function getByRm(rm: string | number) {
  const response = await http
    .getData(`/pasien/${rm}/alergi-obat`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
    return response.data;
}

async function create(data:any) {
  const response = await http.postData("/pasien/alergi-obat", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function update(id: number,data: any) {
  const response = await http
    .putData(`/pasien/alergi-obat/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function destroy(id: number) {
  const response = await http
    .deleteData(`/pasien/alergi-obat/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}



export default {
  getByRm,
  create,
  update,
  destroy
};
